import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import { environment } from 'environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { User } from 'aws-sdk/clients/appstream';


@Injectable()
export class ContribService {
  private baseUrl = environment.API;
  public isModalShown = false;
  public modalType = 'login';
  public storyCover;
  private $owner: any;
  public _owner: BehaviorSubject<any> = new BehaviorSubject<any>('');
  public owner: Observable<any> = this._owner.asObservable();
  private $projectInfo: Array<any>;
  public _projectInfo: BehaviorSubject<any> = new BehaviorSubject<any>('');
  public projectInfo: Observable<any> = this._projectInfo.asObservable();

  constructor(
    private http: HttpClient,
    private dom: DomSanitizer
  ) {}

  getProjectInfo(projectId: string): Observable<any> {
    return this.http.get<any>( this.baseUrl + '/projects/' + projectId + '/')
    .pipe(
        map(response => {
            this.projectInfo = response;
            return response;
        }
    ));
  }

  getOwnerInfo(OwnerId: string) {
    return this.http.get<any>( this.baseUrl + '/users/' + OwnerId + '/public')
    .pipe(
        map(response => {
            this.owner = response;
            return(response);
        }
    ));
  }

  getInvitationLink(projectId: string) {
    return this.http.post<any>( this.baseUrl + '/invitations/project/' + projectId, { 'role': 'contributor'})
    .pipe(
        map(invitation => {
          return(invitation);
        }
    ));
  }

}
